import { createAsyncThunk } from '@reduxjs/toolkit';
import { hrControlService } from './HRVacancies.service';
import { errorHandlerThunk } from '../../App/App.thunk';
import { WidgetRegionJobDTO } from './HRVacancies.type';

const THUNK_PREFIX = 'hrVacancies';

export const getHRVacanciesListThunk = createAsyncThunk(
  `${THUNK_PREFIX}/getHRVacanciesListThunk`,
  async ({region_id, ...params}: any, thunkAPI) => {
    try {
      const { data } = await hrControlService.getList(region_id, params);
      data.data = data.data.map(hr => ({
        ...hr,
        fullName: hr.user_name
      }));
      return data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const updateHRVacanciesCommentThunk = createAsyncThunk(
  `${THUNK_PREFIX}/updateHRVacanciesCommentThunk`,
  async (payload: {id: number; comment: Pick<WidgetRegionJobDTO, 'comment'>}, thunkAPI) => {
    try {
      const response = await hrControlService.update(payload);
      return response.data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  },
);

export const addWidgetRegionJobThunk = createAsyncThunk(
  `${THUNK_PREFIX}/addWidgetRegionJobThunk`,
  async (payload: WidgetRegionJobDTO, thunkAPI) => {
    try {
      const { data } = await hrControlService.add(payload);
      return data;
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  });

export const deleteWidgetRegionJobThunk = createAsyncThunk(
  `${THUNK_PREFIX}/deleteWidgetRegionJobThunk`,
  async (id: number, thunkAPI) => {
    try {
      return await hrControlService.delete(id);
    } catch (error) {
      throw thunkAPI.dispatch(errorHandlerThunk(error));
    }
  }
)
